// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3IvDN","boxTitle":"Qualiphy_boxTitle__1UqsE","box":"Qualiphy_box__uPqv0","toggleWrap":"Qualiphy_toggleWrap__v7J-H"};